/**
 * 登录信息模块下的接口
 */
import { _get, _post, _put } from '@/common/request';
// 重置密码
export function resetPassword(params) {
    return _put('/property/user/reset', params, true);
}
// 用户登录
export function userLogin(params) {
    return _post('/property/user/login', params, true);
}
// 退出登录
export function userLogout() {
    return _get('/property/user/logout', null, true);
}
// 获取企业微信授权链接
export function getAuthorizationUrl(params) {
    return _get('/external/wecom/single_url', params, true);
}
// 企业微信扫码授权登录
export function getAuthInfoByCode(params) {
    return _get('/external/wecom/login/auth_code', params, true);
}
// 获取钉钉授权链接
// https://yapi.lanhanba.com/project/140/interface/api/25494
export function getDingTalkAuthorizationUrl(params) {
    return _get('/external/dingtalk/single_url', params, true);
}
// 钉钉扫码授权登录
// https://yapi.lanhanba.com/project/140/interface/api/25487
export function getDingTalkAuthInfoByCode(params) {
    return _get('/external/dingtalk/login/auth_code', params, true);
}
// 钉钉-免登码登陆（应用内）
// https://yapi.lanhanba.com/project/140/interface/api/25501
export function getDingTalkAuthInfoByFreeCode(params) {
    return _get('/external/dingtalk/login/code', params, true);
}
// 获取手机验证码
// https://yapi.lanhanba.com/project/140/interface/api/17409
export function getMobileSMS(params) {
    return _put('/external/mobile/sms', params, true);
}
// 绑定手机号
// https://yapi.lanhanba.com/project/140/interface/api/17413
export function bindUserMobile(params) {
    return _put('/external/mobile/bind', params, true);
}
// 运营后台登录
export function pmsAdminLogin(id) {
    return _get("/admin/admins/company_admin/" + id, null, { needPrefix: false });
}
// 获取登录验证码
export function getLoginCode(params) {
    return _post("/property/user/sendSms", params, true);
}
// 判断邀请码
// https://yapi.lanhanba.com/project/319/interface/api/42769
export function checkInviteCode(params) {
    return _get("/property/invite/decode", params, true);
}
// 发送语音验证码
// https://yapi.lanhanba.com/project/319/interface/api/86680
export function sendVoiceCode(params) {
    return _post("/property/user/sendVoiceSms", params, true);
}
